// extracted by extract-css-chunks-webpack-plugin
module.exports = {"header_wp":"header_wp-P7j7l62T","header":"header-3XiCFIh0","linkList":"linkList-27JSm4uY","home":"home-2dJvohpP"};